/* eslint-disable camelcase */
import { InvoiceTemplateStatusEnum } from '../enums/invoiceTemplateStatus.enum';
import { BaseOptions } from './baseOptions';

export class InvoiceTemplateOptions extends BaseOptions {
  owner_id?: number;

  status?: InvoiceTemplateStatusEnum;

  showFormInfo?: boolean;

  filter?: string;

  constructor(params?: { owner_id?: number; filter?: string }) {
    super();

    this.sortCol = 'owner_id';
    this.sortDir = 'desc';

    if (params?.owner_id) {
      this.owner_id = params.owner_id;
    }
    if (params?.filter) {
      this.filter = params.filter;
    }
  }
}
